import React, { useState } from "react";
import { FiX, FiCopy, FiCheck } from "react-icons/fi";

// Shows the exact structure of a Firestore document — pretty-printed JSON,
// with a one-click copy — so admins don't need to open the Firebase console
// just to check what's actually stored on a lesson or user.
function DocViewerModal({ open, onClose, path, data }) {
    const [copied, setCopied] = useState(false);
    if (!open) return null;

    const json = JSON.stringify(data, null, 2);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(json);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch {
            // clipboard API unavailable — silently ignore, the JSON is still selectable/visible
        }
    };

    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
                display: "flex", alignItems: "center", justifyContent: "center",
                zIndex: 1000, padding: 24,
            }}
        >
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: "#fff", borderRadius: 18, width: "100%", maxWidth: 760,
                    maxHeight: "85vh", display: "flex", flexDirection: "column",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.28)", overflow: "hidden",
                    fontFamily: "'Quicksand', sans-serif",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: "1px solid #eee", gap: 12 }}>
                    <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: "#888" }}>
                            Firestore Document
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 700, color: "#2a9d8f", fontFamily: "monospace", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {path}
                        </div>
                    </div>
                    <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                        <button
                            type="button"
                            onClick={handleCopy}
                            title="Copy JSON"
                            style={{
                                display: "flex", alignItems: "center", gap: 6, padding: "8px 14px", borderRadius: 10,
                                border: `1.5px solid ${copied ? "#50C878" : "#2a9d8f"}`,
                                background: copied ? "#50C878" : "#fff",
                                color: copied ? "#fff" : "#2a9d8f",
                                fontWeight: 700, fontSize: 13, cursor: "pointer", fontFamily: "'Quicksand', sans-serif",
                            }}
                        >
                            {copied ? <FiCheck size={14} /> : <FiCopy size={14} />} {copied ? "Copied" : "Copy JSON"}
                        </button>
                        <button
                            type="button"
                            onClick={onClose}
                            title="Close"
                            style={{ width: 36, height: 36, borderRadius: 10, border: "1.5px solid #E0E0E0", background: "#fff", color: "#606060", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
                        >
                            <FiX size={16} />
                        </button>
                    </div>
                </div>
                <pre style={{
                    margin: 0, padding: 20, overflow: "auto", fontSize: 12.5, lineHeight: "19px",
                    fontFamily: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace",
                    background: "#0d1117", color: "#c9d1d9", flex: 1,
                }}>
                    {json}
                </pre>
            </div>
        </div>
    );
}

export default DocViewerModal;
